import { SET_LOADING, SAVE_DATA } from './constants';
import { CLEAR_STATE } from '../HandleAPICalls/constants';

const initialState = {
  loading: true,
  list: [],
  vmDetails: null
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.isLoading
      };

    case SAVE_DATA:
      return {
        ...state,
        list: action.data.list,
        vmDetails: action.data.vmDetails
      };

    case CLEAR_STATE:
      return initialState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Modules/VMDetails/reducer.js